import { render, staticRenderFns } from "./vdeoCourse.vue?vue&type=template&id=5f91948c&scoped=true&"
import script from "./vdeoCourse.vue?vue&type=script&lang=js&"
export * from "./vdeoCourse.vue?vue&type=script&lang=js&"
import style0 from "./vdeoCourse.vue?vue&type=style&index=0&id=5f91948c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f91948c",
  null
  
)

export default component.exports